module.exports = __webpack_public_path__ + "img/dp-category.9b77f916.svg";